import { FieldNames } from 'Src/constants/FieldNames'
import { BankGuaranteeFull, defaultValue, DependentFieldsBg, unRequiredFields } from 'Pages/ibro'
import { intersection } from 'lodash'

export const getRequiredFields = <
	T extends { required_fields: BankGuaranteeFull['required_fields'] }
>(
	formValues: Record<string, unknown>,
	item: T,
	dependentFields?: DependentFieldsBg
): FieldNames[] => {
	const dependentRequiredFields = dependentFields
		? (Object.keys(dependentFields) as (keyof DependentFieldsBg)[]).reduce(
				(dependent, fieldName) => {
					dependentFields[fieldName]?.forEach((dependentField): void => {
						if (dependentField.values?.includes(formValues[fieldName]))
							dependent.required.push(...dependentField.required_fields)
						dependent.all.push(...dependentField.required_fields)
					})
					return dependent
				},
				{ required: [], all: [] } as { required: FieldNames[]; all: FieldNames[] }
		  )
		: ({ required: [], all: [] } as { required: FieldNames[]; all: FieldNames[] })

	return intersection(
		[
			...item.required_fields.filter((field) => !dependentRequiredFields.all.includes(field)),
			...dependentRequiredFields.required,
		],
		Object.keys(formValues) as FieldNames[]
	).filter((field) => !unRequiredFields.includes(field))
}

export const currencyFormat = (val: string) =>
	val ? Intl.NumberFormat('ru-RU', { minimumFractionDigits: 2 }).format(Number(val)) : ''

export const isAuthPassport = (val: string) =>
	val?.toLowerCase() === defaultValue[FieldNames.AUTHPASSPORT].toLowerCase()

export const normalizePhone = (value: string) => {
	if (!value) return value
	if (value.length === 1) {
		return `+7${value.replace(/[^\d]/g, '')}`
	}

	const onlyNums = value.replace(/[^\d]/g, '')
	return `+${onlyNums}`
}
